import React, {useRef, useState, useEffect  } from "react";
import { Uploader, Progress, Button } from "rsuite";
import iconUpload from "../images/iconUpload.svg";
import iconJPG from '../images/iconJPG.svg';
import iconPNG from '../images/iconPNG.svg';
import iconPDF from '../images/iconPDF.svg';
import iconCancel from '../images/iconCancel.svg';
import { Link, useNavigate } from "react-router-dom";

const TooltipTest = () => {
  const apiEndPoint = process.env.REACT_APP_API_ENDPOINT;

  const [uploadedfileList, setUploadedFileList] = useState([]);  
  const [progress, setProgress] = useState({});
  const [timeRemaining, setTimeRemaining] = useState({});
  const [preview, setPreview] = useState("");
  const [reportType, setReportType] = useState("");
  const [taskId, settaskId] = useState(126); // This will remove
  const userid = localStorage.getItem("novauserid"); // this will remove

  const [showUploadManualModal, setUploadManualModal] = useState(false);  
  const closeUploadManualModal = () => setUploadManualModal(false);

  const [showUploadpreviewModal, setUploadpreviewModal] = useState(false);
  const closeUploadpreviewModal = () => setUploadpreviewModal(false);

  
  // Function to handle file selection and upload
  const handleFileSelect = async (file) => {
    if (!file || !file.blobFile) return;

    const newFile = {
      file: file.blobFile,
      name: file.name,
      url: URL.createObjectURL(file.blobFile),
      startTime: Date.now(),
      progress: 0,
      status: "Uploading...", // Initial status
    };

    setUploadedFileList((prevFiles) => [...prevFiles, newFile]); // Append new file to list
    await uploadFile(newFile);
  };

  // Function to upload files to the API
  const uploadFile = async (fileObj) => {
    
    setProgress((prev) => ({ ...prev, [fileObj.name]: 0 }));
  
    const formData = new FormData();
    formData.append("task_id", taskId);
    formData.append("files[]", fileObj.file);
  
    let progressValue = 0;
    const startTime = Date.now();
  
    // Fake progress update every 500ms
    const interval = setInterval(() => {
      progressValue += Math.random() * 10; // Random increment
      progressValue = Math.min(progressValue, 95); // Max 95% tak jayega
      
      setProgress((prev) => ({ ...prev, [fileObj.name]: Math.round(progressValue) }));
    }, 500);
  
    try {
      const response = await fetch(`${apiEndPoint}/upload_task_files`, {
        method: "POST",
        body: formData,
      });
  
      const result = await response.json();
      console.log(`Upload Success: ${fileObj.name}`, result);
  
      if (result?.data?.status === "success" && result?.data?.files?.length > 0) {
        const newFiles = result.data.files.map((file) => ({
          id : file.id,
          name: file.title,
          fileKey: file.id,
          url: file.file_url,
          type : file.file_type,
          size : file.file_size,
        }));
        setUploadedFileList(newFiles);
      }
  
      // Once upload completes, set progress to 100%
      setProgress((prev) => ({ ...prev, [fileObj.name]: 100 }));
      
    } catch (error) {
      console.error(`Upload Failed: ${fileObj.name}`, error);
    } finally {
      clearInterval(interval); // Stop progress updates
      
    }
  };
  
  // Function to calculate time remaining based on upload speed
const updateTimeRemaining = (fileName, uploadedSize, totalSize, startTime) => {
  const elapsedTime = (Date.now() - startTime) / 1000; // in seconds
  const uploadSpeed = uploadedSize / elapsedTime; // bytes per second
  const remainingSize = totalSize - uploadedSize;
  const estimatedTime = uploadSpeed > 0 ? remainingSize / uploadSpeed : 0;

  setTimeRemaining((prev) => ({
    ...prev,
    [fileName]: estimatedTime.toFixed(2),
  }));
};

const renderProgress = (file) => {
  return (
    <div key={file.name} style={{ marginTop: 10 }}>
      <p>
        {file.name} - {file.status}
      </p>
      <div style={{ width: "100%", background: "#ccc", borderRadius: 5 }}>
        <div
          style={{
            width: `${progress[file.name] || 0}%`,
            background: "#4caf50",
            height: "10px",
            borderRadius: 5,
          }}
        ></div>
      </div>
      <p>{progress[file.name] || 0}% uploaded</p>
      {file.status === "Uploading..." && (
        <p>Time Remaining: {timeRemaining[file.name] || "Calculating..."} sec</p>
      )}
    </div>
  );
};




  const getFileIcon = (fileType) => {
    if (fileType.includes('jpeg') || fileType.includes('jpg')) return iconJPG;
    if (fileType.includes('png')) return iconPNG;
    if (fileType.includes('pdf')) return iconPDF;
    return null;
  };

  const handleRemove = async (file) => {
    console.log('Removed file:', file);
  
    const url = `${apiEndPoint}/delete_task_file`;
  
    const requestData = {
      data: {
        user_id: userid,
        file_id: file.fileKey,
        task_id: taskId,
      }
    };
  
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestData)
      });
  
      const result = await response.json();
      console.log('API Response:', result);
  
      if (result?.data?.status === 'success') {
        console.log('File deleted successfully:', file.fileKey);
      
        const newFiles = result.data.files.map((file) => ({
          id : file.id,
          name: file.title,
          fileKey: file.id,
          url: file.file_url,
          type : file.file_type,
          size : file.file_size,
        }));
        setUploadedFileList(newFiles);

      } else {
        console.error('Failed to delete file:', result?.data?.message || 'Unknown error');
      }

      // Agar API success response de to file list se remove karne ka logic yahan likho
    } catch (error) {
      console.error('Error deleting file:', error);
    }
  };
  


  const handleUploadClick = async () => {
    try {
      const response = await fetch(`${apiEndPoint}/get_task_files`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: {
            user_id: userid,
            task_id: taskId,
          },
        }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      if (result?.data?.status === "success" && result?.data?.files?.length > 0) {
        const newFiles = result.data.files.map((file) => ({
          id : file.id,
          name: file.title,
          fileKey: file.id,
          url: file.file_url,
          type : file.file_type,
          size : file.file_size,
        }));
  
       // setUploadedFileList((prev) => [...prev, ...newFiles]);
       setUploadedFileList(newFiles);
       
      }
      setUploadManualModal(true);
      //setFiles(result.data); // API response ke `data` ko store kar rahe hain
      console.log("Files:", result);
    } catch (error) {
      console.error("Error fetching task files:", error);
    }
  };

  const handleClick = (file) => {
    setReportType(file.type);
    setPreview(file.url);
    setUploadpreviewModal(true);

  };




  return (
    <>
      <div style={{ margin: 30 }}>
        <button className="btn__upload__local__file"  onClick={handleUploadClick}>Upload Local Files</button>
        {/* <button className="btn__upload__local__file" data-bs-toggle="modal" data-bs-target="#UploadFileModal">
          Upload Local Files
        </button> */}
      </div>

     
                

      <div  className={`modal fade upload_file_modals ${showUploadManualModal ? "d-block show" : "d-none"}`} id="UploadFileModal" tabIndex="-1" aria-labelledby="UploadFileModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 760 }}>
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title fs-5">Upload Local Files</h4>
              <p>Add your documents here, and you can upload up to 15 MB files max</p>
            </div>
            <div className="modal-body">
              <div className="upload_section_main">
                <Uploader
                  action=""
                  draggable
                  multiple // Allow multiple files
                  listType="text"
                  accept=".jpg,.png,.pdf"
                  onChange={(files) => files.forEach((file) => handleFileSelect(file))}
                  //defaultFileList={fileList1}
                  fileList={uploadedfileList}
                  fileListVisible={false} // file list visible nahi hogi.
                   //onRemove={handleRemove}
                >
                  <div>
                    <div className="upload_section">
                      <img src={iconUpload} alt="Upload Icon" />
                      <p>Drag your file(s) to start uploading</p>
                      <div className="or__text"><span>OR</span></div>
                      <span className="btn__browse__file">Browse files</span>
                    </div>
                    <h6 style={{marginBottom:10}}>Only support .jpg, .png, .pdf and .xlsx files</h6>
                  </div>
                </Uploader>

                <div className="customUploadwrap">
  {uploadedfileList.map((file) => {
    const percent = progress[file.name] || 101;
    const elapsedTime = (Date.now() - file.startTime) / 1000; // in seconds
    const estimatedTimeRemaining =
      percent > 0 ? Math.max(((100 - percent) * elapsedTime) / percent, 1) : 0;

    return (
      <div key={file.id} className="customUploadList">
        {percent < 100 ? (
          // **Uploading Section**
          <div>
            <div className="progress_row">
              <div className="progress_text">
                <h4>Uploading...</h4>
                <p>
                  {percent}% <span> • {Math.round(estimatedTimeRemaining)} seconds remaining</span>
                </p>
              </div>
            </div>
            <Progress.Line percent={percent} showInfo={false} strokeColor="#2B3779" />
          </div>
        ) : (
          // **Uploaded Section**
          <div className="customUploadProgress_row">
            <div className="filename_row">
              <div className="class_icon" style={{cursor:'pointer'}}>
              {/* <Link  to={file.type === "pdf" ? `https://docs.google.com/viewer?url=${encodeURIComponent(file.url)}` : file.url} target="_blank" rel="noopener noreferrer"> */}
              <img src={file.type == "pdf" ? iconPDF : file.type == "png" ? iconPNG : iconJPG}  onClick={() => handleClick(file)}  />
              {/* </Link> */}
              </div>
              <div className="class_filename">
                <h5>{file.name}</h5>
                <span className="file_size">{file.size} -{file.id}</span>
              </div>
            </div>
            <button className="cls_btn_cross"  onClick={() => handleRemove(file)}>
              <img src={iconCancel} />
            </button>
          </div>
        )}
      </div>
    );
  })}
</div>


     


              </div>

              <div className="btn__group mt-5">
                <button type="button" className="btn_cancel" onClick={closeUploadManualModal}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>


<div class={`modal fade upload_file_modal ${showUploadpreviewModal ? "d-block show" : "d-none"}`} id="ModalManualReport" tabindex="-1" aria-labelledby="AddNewAnalystModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
          <div class="modal-dialog modal-dialog-centered" >
              <div class="modal-content">
                <button type="button" class="btn-close"  aria-label="Close" onClick={closeUploadpreviewModal}></button>
                <div class="modal-body">
              {reportType === "pdf" ? (
                <iframe
                  title="LR Report PDF"
                  width="100%"
                  height="550"
                  src={preview}
                  className="iframe_pdf"
                ></iframe>
          ) : (
            <div className="upload_img_modal">
              <img src={preview} alt="Preview" />
            </div>
          )}
                
                </div>    
              </div>
          </div>
      </div>

    </>
  );
};

export default TooltipTest;
